import { engine } from "@verified/c11-engine.runtime";
import { render } from "@verified/c11-engine.react";
import { App } from "./App";
import "./global";
import "./styles.css";

const state: State = {
  name: "John Doe",
  greeting: "Hello",
  envelopes: undefined,
  langId: "sv-SE",
  langMenuOpen: false,
  languageChoice: "SE",
  loggedOut: false,
  isReady: {
    languages: false
  },
  isLoading: false
};

const app = engine({
  state,
  use: [
    render(<App />, "#app", {
      debug: false,
    }),
  ],
});

app.start();

// Each renderer can have a state where it stores if it finished rendering/mounting/etc
// This can be used to hook-up processes for export for example
